import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

// URL state lets refresh, bookmarks, and browser history restore an admin panel.
export default function useAdminSection(initial = false) {
  const [params, setParams] = useSearchParams();
  const value = params.get("section") || initial;
  const setValue = useCallback((next) => {
    setParams((previous) => {
      const updated = new URLSearchParams(previous);
      if (next) updated.set("section", next);
      else updated.delete("section");
      return updated;
    });
  }, [setParams]);
  return [value, setValue];
}
